@if (fileForm) {
  <div
    [formGroup]="fileForm"
    class="wcg-upload-file-row grid grid-cols-3 gap-4"
    [ngClass]="!isLast() ? 'border-b-2' : ''"
    data-testid="upload-file-row"
  >
    <div data-testid="file-name" class="flex justify-between items-center">
      <div class="wcg-upload-file-row__text" [matTooltip]="fileName">
        {{ fileName }}
      </div>
      <div class="wcg-upload-file-row__error-container">
        @if (file?.hasError("fileNameExceedsLimit")) {
          <wcg-error
            class="wcg-input__error"
            data-testid="file-name-length-error"
          >
            The file name exceeds 255 characters
          </wcg-error>
        }
        @if (file?.hasError("fileSizeExceedsLimit")) {
          <wcg-error class="wcg-input__error" data-testid="file-size-error">
            This file exceeds 1 GB
          </wcg-error>
        }
        @if (file?.hasError("invalidFileType")) {
          <wcg-error class="wcg-input__error" data-testid="file-type-error">
            This is not a valid file type
          </wcg-error>
        }
      </div>
    </div>

    <div class="flex justify-between items-center">
      <div class="wcg-select compact" data-testid="file-type-select-container">
        <mat-form-field
          [class.error]="
            documentType?.invalid &&
            (documentType?.dirty || documentType?.touched)
          "
          appearance="outline"
          data-testid="file-type-form-field"
        >
          <mat-select
            matNativeControl
            formControlName="documentType"
            data-testid="file-type-select"
            placeholder="Select Document Type"
            (selectionChange)="onDocumentTypeChange()"
          >
            @for (documentType of documentTypes(); track documentType.name) {
              <mat-option
                [value]="documentType.name"
                data-testid="file-type-option"
              >
                {{ documentType.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (
          documentType?.invalid &&
          (documentType?.dirty || documentType?.touched)
        ) {
          <wcg-error class="wcg-input__error" data-testid="document-type-error">
            Document type is required
          </wcg-error>
        }
      </div>
    </div>

    <div class="flex justify-between items-center">
      <div class="wcg-select compact" data-testid="file-type-select-container">
        <mat-form-field
          [class.error]="
            documentName?.invalid &&
            (documentName?.dirty || documentName?.touched)
          "
          appearance="outline"
          data-testid="document-name-form-field"
        >
          <mat-select
            matNativeControl
            formControlName="documentName"
            data-testid="document-name-select"
            placeholder="Select Document Name"
          >
            <mat-option
              value="Optional"
              data-testid="document-name-default-option"
            >
              Optional
            </mat-option>
            @for (doc of requiredTypesForSubmission(); track doc.id) {
              @if (
                doc.document_type.name === fileForm.get("documentType")?.value
              ) {
                <mat-option
                  [value]="doc.document_type.title"
                  data-testid="document-name-option"
                >
                  {{ doc.document_type.title }}
                </mat-option>
              }
            }
          </mat-select>
        </mat-form-field>
        @if (
          documentName?.invalid &&
          (documentName?.dirty || documentName?.touched)
        ) {
          <wcg-error class="wcg-input__error" data-testid="document-name-error">
            Document name is required
          </wcg-error>
        }
      </div>

      <button
        mat-mini-fab
        wcg-icon-button
        iconSize="large"
        aria-label="delete file btn"
        (click)="deleteFile()"
        data-testid="delete-file-btn"
        class="color-bluegrey-15"
      >
        <mat-icon
          class="material-icons-outlined color-bluegrey-15"
          fontIcon="delete_outline"
          style="color: #3a424a"
        />
      </button>
    </div>
  </div>
}
